export const SEARCH_HISTORY_LOCAL_KEY = 'search_suggestions_latest_queries'
export const SEARCH_HISTORY_MAX_ITEMS = 5
export const MIN_ACCEPTABLE_QUERY_LENGTH = 1
